export default "__VITE_ASSET__DKUoAAio__"